import { Component, Input } from '@angular/core';
import { JobContact } from '../../../../Jobbing/models/JobContact';
import { JobAddressSelection } from '../../../../Jobbing/models/JobAddressSelection';

@Component({
  selector: 'app-job-to-location-details-box',
  standalone: true,
  templateUrl: './job-to-location-details-box.component.html',
  styleUrl: './job-to-location-details-box.component.scss'
})
export class JobToLocationDetailsBoxComponent {
  @Input()
  toJobAddress?: JobAddressSelection | null;

  @Input()
  toJobContact?: JobContact | null;
}
